/**
 * 多选题类型定义
 */

import { QuestionType } from '../../types';
import type { QuestionTypeMetadata } from '../types';

export const multipleChoiceTypeMetadata: QuestionTypeMetadata = {
  type: QuestionType.MULTIPLE_CHOICE,
  name: '多选题',
  description: '可以有多个正确答案的选择题',

  requiredFields: ['content', 'options', 'correctAnswer'],
  optionalFields: ['explanation', 'difficulty', 'tags', 'imageUrl', 'section', 'level'],

  fields: {
    content: {
      name: 'content',
      type: 'text',
      required: true,
      description: '题目内容',
    },
    options: {
      name: 'options',
      type: 'array',
      required: true,
      description: '选项列表',
      validator: (value) => {
        if (!Array.isArray(value) || value.length < 2) {
          return '选项至少需要2个';
        }
        const correctCount = value.filter((opt: any) => opt.isCorrect === true).length;
        if (correctCount < 2) {
          return '多选题至少需要2个正确答案';
        }
        return true;
      },
    },
    correctAnswer: {
      name: 'correctAnswer',
      type: 'array',
      required: true,
      description: '正确答案列表（选项ID数组）',
      validator: (value) => {
        if (!Array.isArray(value) || value.length < 2) {
          return '多选题至少需要2个正确答案';
        }
        return true;
      },
    },
    explanation: {
      name: 'explanation',
      type: 'text',
      required: false,
      description: '题目解析',
    },
    imageUrl: {
      name: 'imageUrl',
      type: 'url',
      required: false,
      description: '题目图片URL',
    },
  },

  validate: (question: any) => {
    const errors: any[] = [];

    if (!question.content || typeof question.content !== 'string') {
      errors.push({
        field: 'content',
        message: '题目内容不能为空',
        code: 'MISSING_CONTENT',
      });
    }

    if (!question.options || !Array.isArray(question.options) || question.options.length < 2) {
      errors.push({
        field: 'options',
        message: '至少需要2个选项',
        code: 'INVALID_OPTIONS',
      });
    }

    if (
      !question.correctAnswer ||
      !Array.isArray(question.correctAnswer) ||
      question.correctAnswer.length < 2
    ) {
      errors.push({
        field: 'correctAnswer',
        message: '多选题至少需要2个正确答案',
        code: 'INVALID_ANSWER',
      });
    }

    // 验证所有正确答案是否在选项中
    if (question.options && question.correctAnswer) {
      const optionIds = question.options.map((opt: any) => opt.id);
      const invalidAnswers = question.correctAnswer.filter(
        (ans: string) => !optionIds.includes(ans)
      );
      if (invalidAnswers.length > 0) {
        errors.push({
          field: 'correctAnswer',
          message: `以下答案不在选项列表中: ${invalidAnswers.join(', ')}`,
          code: 'ANSWER_NOT_IN_OPTIONS',
        });
      }
    }

    return {
      valid: errors.length === 0,
      errors,
    };
  },

  renderConfig: {
    layout: 'default',
    showFields: ['content', 'imageUrl', 'options'],
  },
};
